import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modalSm: {
    minWidth: 300,
    [theme.breakpoints.down("xs")]: {
      minWidth: "auto",
    },
  },
  modalMd: {
    minWidth: 400,
    [theme.breakpoints.down("xs")]: {
      minWidth: "auto",
    },
  },
  modalLg: {
    minWidth: 600,
    [theme.breakpoints.down("xs")]: {
      minWidth: "auto",
    },
  },
  modalXl: {
    minWidth: 750,
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      maxWidth: "100%",
    },
  },
  modalXXl: {
    minWidth: "90%",
    maxWidth: "90%",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      maxWidth: "100%",
    },
  },
  modalHeader: {
    zIndex: 3,
    boxShadow: "0px 3px 6px #00000029",
  },
  modalTitle: {
    padding: "8px !important",
    maxWidth: "60%",
    textTransform: "none",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "50%",
    },
    "& h2": {
      fontSize: 16,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      [theme.breakpoints.down("xs")]: {
        whiteSpace: "unset",
        lineHeight: "20px",
      },
    },
  },
  modalContent: {
    padding: "24px 24px 40px",
    "&.is-scroll": {
      paddingTop: 0,
      "& .MuiAppBar-root": {
        paddingTop: 20,
        zIndex: 2,
      },
      "& .kpi-tab-item": {
        "& .kpi-icon": {
          display: "none",
        },
        "& h6": {
          display: "none",
          // animation: `$myEffect 1000ms ${theme.transitions.easing.easeOut}`,
        },
      },
    },
    "& .horizontal-tab": {
      overflow: "unset",
    },
  },

  // "@keyframes myEffect": {
  //   "0%": {
  //     opacity: 1,
  //     height: "auto",
  //   },
  //   "100%": {
  //     opacity: 0,
  //     height: 0,
  //   },
  // },

  infoText: {
    fontFamily: "inherit",
    color: "#C2BDBD",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& svg": {
      marginRight: 3,
    },
  },
  formLabel: {
    margin: "30px 0 15px",
  },
  errorMessages: {
    color: "#F36F6F",
    fontSize: 13,
    marginTop: 3,
  },
  closeModal: {
    position: "fixed",
    top: 5,
    right: 5,
    color: "#fff",
  },
  uploadUser: {
    "& a": {
      padding: 0,
      // fontSize: 16,
      margin: "5px 0 15px",
    },
    "& .MuiDropzonePreviewList-imageContainer": {
      "& .MuiChip-root": {
        borderRadius: 4,
        background: theme.palette.secondary.light,
        borderColor: theme.palette.secondary.main,
        "& svg": {
          width: 16,
        },
      },
    },
  },
  dropzone: {
    "& .MuiDropzoneArea-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 15,
      "&:focus": {
        border: "dashed 2px gray",
        outline: "none",
      },
      "&:hover": {
        "& .MuiDropzoneArea-text": {
          color: theme.palette.primary.main,
        },
        "& svg": {
          color: theme.palette.primary.main,
        },
      },
    },
    "& .MuiDropzoneArea-text": {
      color: "#777",
      fontSize: 18,
      fontWeight: 300,
    },
    "& .MuiDropzoneArea-textContainer": {
      "& svg": {
        color: "#777",
        animation: "$bounce 1s infinite alternate",
      },
    },
    "& .MuiTypography-subtitle1": {
      fontSize: 14,
    },
  },
  "@keyframes bounce": {
    from: {
      transform: "translateY(0px)",
    },
    to: {
      transform: "translateY(-10px)",
    },
  },
  errorMsg: {
    color: "#F36F6F",
    marginBottom: 10,
  },
  successMsg: {
    color: "#009C55",
    marginBottom: 10,
  },
  radioBlock: {
    "& .MuiFormGroup-root": {
      flexDirection: "column",
    },
  },
  actionsDivider: {
    borderTop: "dashed 1px #707070",
    marginBottom: "-20px",
  },
  targetModalBanner: {
    margin: "-20px -24px 0",
  },
  btnlink: {
    padding: "0",
    minWidth: "40px",
    marginRight: 5,
    border: "solid 1px #C2BDBD",
    borderRadius: 20,
    height: 24,
    background: "#fff",
    "&:hover": {
      background: "#fff",
    },
    "& svg": {
      fontSize: 16,
    },
    "&:last-child": {
      marginRight: 0,
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: 10,
    },
  },
  // target user modal
  targetUserList: {
    listStyle: "none",
    padding: 0,
    "& li": {
      marginBottom: 16,
    },
  },
  lineChart: {
    "& .k-chart": {
      width: 700,
    },
  },
  downloadReportHeader: {
    backgroundColor: "#DDF2FF",
    height: "10%",
  },
  ObjectiveListModal: {
    "& .obj-comment": {
      display: "none",
    },
    "& li": {
      margin: 0,
      "& p": {
        fontSize: 14,
      },
    },
    "& .MuiIconButton-root": {
      border: "solid 1.5px #ccc",
      width: 30,
      height: 22,
      "& svg": {
        color: "#000",
        fontSize: 15,
      },
    },
    "& .action-button-group": {
      minWidth: 116,
      padding: "12px 0",
      borderLeft: "solid 1px #ccc",
      paddingLeft: 10,
      "& .markCompleteSelected": {
        background: "#28c37b !important",
        "& svg": {
          color: "#fff !important",
        },
      },
      "& .inProgressSelected": {
        background: "#f2692a !important",
        "& svg": {
          color: "#fff !important",
        },
      },
      "& .needHelpSelected": {
        background: "#f43e53 !important",
        "& svg": {
          color: "#fff !important",
        },
      },
      "& .spinner-wrapper": {
        width: 35,
        height: 22,
        padding: 3,
      },
    },
  },
  targetHeader: {
    "& .MuiTypography-subtitle1": {
      fontSize: 16,
      fontWeight: 500,
    },
  },
  ratingRadioGrid: {
    "& .MuiBox-root": {
      "&:first-child": {
        "& .MuiFormGroup-root": {
          flexDirection: "column",
        },
      },
    },
    // "& .MuiFormControlLabel-root": {
    //   width: "16.66%",
    //   margin: 0,
    //   [theme.breakpoints.down("sm")]: {
    //     width: "33.33%",
    //     marginBottom: 15,
    //   },
    //   [theme.breakpoints.down("xs")]: {
    //     width: "100%",
    //   },
    // },
    // "& .MuiRadio-root": {
    //   padding: "0 5px 0 0",
    // },
  },
  isScroll: {
    "& .kpi-tab-item": {
      "& img": {
        display: "none",
      },
      "& h6": {
        display: "none",
      },
    },
  },
  userList: {
    background: "#eee",
    padding: "15px 20px",
    margin: "5px 0 0",
    "& li": {
      display: "flex",
      alignItems: "center",
      listStyle: "none",
      marginBottom: 10,
      "& .MuiAvatar-root": {
        width: 30,
        height: 30,
        fontSize: 15,
      },
    },
  },
  userProfile: {
    width: "40%",
  },
  // new modal css
  transparentDialog: {
    "& .MuiDialog-paper": {
      background: "transparent",
      padding: 0,
      boxShadow: "none",
      width: "unset",
    },
    "& .MuiDialogTitle-root": {
      color: "#fff",
      textAlign: "center",
      position: "fixed",
      left: 0,
      right: 0,
      background: "#4b5058",
      "& h2": {
        fontWeight: 500,
      },
      "& .MuiIconButton-root": {
        color: "#fff",
        right: "2%",
      },
    },
    "& .MuiDialogActions-root": {
      display: "none",
    },
  },
  resetIndex: {
    "&.MuiDialog-root": {
      zIndex: "1300 !important",
    },
  },
  smallDialog: {
    "& .MuiDialog-paper": {
      borderRadius: 10,
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      padding: 0,
      [theme.breakpoints.down("xs")]: {
        maxHeight: "100%",
        height: "100%",
        width: "100%",
        margin: 0,
      },
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 680,
    },
  },
  dialogTitle: {
    "& h2": {
      fontSize: 16,
      fontWeight: 600,
    },
    boxShadow: "0px 1px 3px #00000029",
    position: "sticky",
    top: 0,
    zIndex: 2,
    height: 58,
  },
  titleStyle: {
    [theme.breakpoints.down("xs")]: {
      lineHeight: "16px",
    },
  },
  modalTitleBtn: {
    "& .custom-btn": {
      position: "absolute",
      right: 58,
      top: 9,
    },
  },
  dialogContent: {
    padding: "0  !important",
  },
  confirmationModalContent: {
    textAlign: "center",
  },
  dialogActions: {
    justifyContent: "center !important",
    padding: "16px 16px 24px !important",
    "& button": {
      minWidth: 85,
      margin: "0 10px",
    },
  },
  confirmationTitle: {
    fontWeight: 500,
    fontSize: 20,
    padding: 16,
    lineHeight: "28px",
    paddingBottom: 0,
  },
  dialogIcon: {
    width: 70,
    height: 70,
    background: "#F0F2F6",
    borderRadius: "50%",
    margin: "20px auto 0",
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      color: "#8C8D8F",
      width: 34,
      height: 34,
    },
  },
  closeButton: {
    position: "absolute",
    right: 16,
    top: 16,
  },
  contentBody: {
    marginTop: 24,
  },
  modalCheckbox: {
    marginTop: -10,
    "& .MuiFormControlLabel-root": {
      display: "block",
    },
  },
}));

export default useStyles;
